/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { EntityId } from '../../types/api/EntityId';
import { DataState } from '../../types/common/DataState';
import { StoreAction } from '../../types/helpers/StoreAction';
import { Organization } from '../../types/organization/Organization';

export enum OrganizationActions {
  ORGANIZATIONS_WATCHER = 'ORGANIZATIONS_WATCHER',
  ORGANIZATIONS_REQUEST = 'ORGANIZATION_REQUEST',
  ORGANIZATIONS_SUCCESS = 'ORGANIZATION_SUCCESS',
  ORGANIZATIONS_FAILURE = 'ORGANIZATION_FAILURE',

  ORG_DETAILS_WATCHER = 'ORG_DETAILS_WATCHER',
  ORG_DETAILS_REQUEST = 'ORG_DETAILS_REQUEST',
  ORG_DETAILS_SUCCESS = 'ORG_DETAILS_SUCCESS',
  ORG_DETAILS_FAILURE = 'ORG_DETAILS_FAILURE',
}

export type OrganizationDetailsState = {
  isFetching: boolean;
  errorMessage?: string;
  organization?: Organization;
  options?: {
    payload: Organization;
  };
};

export type OrganizationsState = {
  isFetching: boolean;
  options: Organization[];
  errorMessage?: string;
  dataState: DataState;
};

type OrganizationsWatcherAction = {
  type: OrganizationActions.ORGANIZATIONS_WATCHER;
};

type OrganizationsRequestAction = {
  type: OrganizationActions.ORGANIZATIONS_REQUEST;
};

type OrganizationsSuccessAction = {
  type: OrganizationActions.ORGANIZATIONS_SUCCESS;
  payload: { options: Organization[] };
};

type OrganizationsErrorAction = {
  type: OrganizationActions.ORGANIZATIONS_FAILURE;
  payload: { errorMessage?: string };
};

export type OrganizationsActionTypes =
  | OrganizationsWatcherAction
  | OrganizationsRequestAction
  | OrganizationsSuccessAction
  | OrganizationsErrorAction;

export type FetchOrgDetailsActionWatcher = {
  type: OrganizationActions.ORG_DETAILS_WATCHER;
  payload: {
    organizationId: EntityId;
  };
};

export type FetchOrgDetailsActionRequest = {
  type: OrganizationActions.ORG_DETAILS_REQUEST;
};

export type FetchOrgDetailsActionSuccess = {
  type: OrganizationActions.ORG_DETAILS_SUCCESS;
  payload: {
    organization: Organization;
  };
};

export type FetchOrgDetailsActionError = {
  type: OrganizationActions.ORG_DETAILS_FAILURE;
  payload: {
    errorMessage?: string;
  };
};

export type OrganizationDetailsActionTypes =
  | FetchOrgDetailsActionWatcher
  | FetchOrgDetailsActionSuccess
  | FetchOrgDetailsActionRequest
  | FetchOrgDetailsActionError;

export type OrganizationActionTypes = StoreAction<OrganizationActions>;
